'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_WIX_DATA = exports.SET_WIX_DATA = 'SET_WIX_DATA';
var SET_ITEMS = exports.SET_ITEMS = 'SET_ITEMS';
var SET_RENDERED_ITEMS_COUNT = exports.SET_RENDERED_ITEMS_COUNT = 'SET_RENDERED_ITEMS_COUNT';

var VIDEO_PLAY_MODE = exports.VIDEO_PLAY_MODE = 'VIDEO_PLAY_MODE';
var GALLERY_WINDOW_LAYOUT_CHANGED = exports.GALLERY_WINDOW_LAYOUT_CHANGED = 'GALLERY_WINDOW_LAYOUT_CHANGED';
var VIDEO_ENDED = exports.VIDEO_ENDED = 'VIDEO_ENDED';
var VIDEO_ADDED = exports.VIDEO_ADDED = 'VIDEO_ADDED';
var VIDEO_REMOVED = exports.VIDEO_REMOVED = 'VIDEO_REMOVED';
var NAVIGATION_IN = exports.NAVIGATION_IN = 'NAVIGATION_IN';
var EDITOR_MODE_CHANGED = exports.EDITOR_MODE_CHANGED = 'EDITOR_MODE_CHANGED';
var TOGGLE_HOVER_PREVIEW = exports.TOGGLE_HOVER_PREVIEW = 'TOGGLE_HOVER_PREVIEW';
var TOGGLE_ISINVIEW = exports.TOGGLE_ISINVIEW = 'TOGGLE_ISINVIEW';
var SET_VIDEO_PLAY_INDEX = exports.SET_VIDEO_PLAY_INDEX = 'SET_VIDEO_PLAY_INDEX';